export default __webpack_public_path__ + "static/header.arbeiterkammer-391f4c19b2c3f8e061a56d6000d7389d.png";